module.exports = __webpack_public_path__ + "img/my exams.e6b18615.png";